import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  // Check if we are on the home page or a page with a dark hero
  const isDarkHero = location.pathname === '/' || location.pathname.startsWith('/bedrijfswaardering') || location.pathname === '/werkwijze' || location.pathname.startsWith('/kennisbank') || location.pathname.startsWith('/adviseurs') || location.pathname.startsWith('/cases') || location.pathname === '/over-ons';
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Close mobile menu on route change
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);
  const navLinks = [{
    name: 'Bedrijfswaardering',
    path: '/bedrijfswaardering'
  }, {
    name: 'Werkwijze',
    path: '/werkwijze'
  }, {
    name: 'Kennisbank',
    path: '/kennisbank'
  }, {
    name: 'Adviseurs',
    path: '/adviseurs'
  }, {
    name: 'Over ons',
    path: '/over-ons'
  }, {
    name: 'Contact',
    path: '/contact'
  }];
  const headerBg = isScrolled ? 'bg-white/90 backdrop-blur-md shadow-sm border-b border-warmgray/50' : isDarkHero ? 'bg-transparent' : 'bg-offwhite';
  const textColor = isScrolled || !isDarkHero ? 'text-charcoal' : 'text-white';
  const logoColor = isScrolled || !isDarkHero ? 'text-charcoal' : 'text-white';
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${headerBg}`} data-id="element-147">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between" data-id="element-148">
        {/* Logo */}
        <Link to="/" className="transition-opacity duration-300 hover:opacity-80" data-id="element-149">
          <img src="https://cdn.magicpatterns.com/uploads/7P7Rjqo6jkpinM1q8K3tpA/Logo_zonder_tekst.png" alt="Mijn bedrijfswaarderingen" className="h-12 w-auto" data-id="element-150" />
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8" data-id="element-151">
          {navLinks.map(link => <Link key={link.name} to={link.path} className={`text-sm font-medium hover:text-accent transition-colors ${textColor}`} data-id="element-152">
              {link.name}
            </Link>)}
        </nav>

        {/* Desktop CTA */}
        <div className="hidden lg:block" data-id="element-153">
          <Link to="/bedrijfswaardering" className="bg-accent hover:bg-accent-hover text-white px-6 py-2.5 rounded-full text-sm font-medium transition-all shadow-subtle hover:shadow-premium" data-id="element-154">
            Start waardebepaling
          </Link>
        </div>

        {/* Mobile Menu Toggle */}
        <button className={`lg:hidden p-2 ${textColor}`} onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label="Toggle menu" data-id="element-155">
          {mobileMenuOpen ? <X size={24} data-id="element-156" /> : <Menu size={24} data-id="element-157" />}
        </button>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-158">
        {mobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="lg:hidden bg-white border-b border-warmgray overflow-hidden" data-id="element-159">
            <div className="px-6 py-8 flex flex-col gap-6" data-id="element-160">
              {navLinks.map(link => <Link key={link.name} to={link.path} className="text-lg font-medium text-charcoal hover:text-accent" data-id="element-161">
                  {link.name}
                </Link>)}
              <Link to="/bedrijfswaardering" className="bg-accent text-white px-6 py-3 rounded-full text-center font-medium mt-4" data-id="element-162">
                Start waardebepaling
              </Link>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}